import React from "react";
import { showLocalDate, tolocalDate } from "../../../utilities/functions";

const EndDateLocally = ({ row }) => {
  return <div>{showLocalDate(row.endDate)}</div>;
};

export default EndDateLocally;
